import { Component } from '@angular/core';

@Component({
  selector: 'app-nested-sidebar-ethernet-flyer',
  templateUrl: './nested-sidebar-ethernet-flyer.component.html',
  styleUrls: ['./nested-sidebar-ethernet-flyer.component.scss']
})
export class NestedSidebarEthernetFlyerComponent {

  pdf = {
    pdfTitle: '800/400/100G Ethernet Flyer',
    pdfimg: './assets/images/sidebar/NEW_VeEX_D08-00-117_C00_Ethernet_Catalog_FINAL_Press_Page_1.png',
    url: 'gigabitwhitepaper',
    opt: 'BUTTON.DOWNLOAD',
    width: '1221',
    height: '1576'
  };

}
